import { render } from "./BasePage.vue?vue&type=template&id=4c5d5900"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"

import "./BasePage.vue?vue&type=style&index=0&id=4c5d5900&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__